import React, { useRef } from "react";
import { Row } from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { disRememberResetApi } from "../../../api";
import { withRouter } from "react-router-dom";
import i18n from "../../../i18n/locales/config";
import { useTranslation } from "react-i18next";

const ForgotPasswordSecondComp = (props) => {
  const { t, i18n } = useTranslation();
  const form = useRef(null);
  const initialLoginValues = {
    token: "",
    email: "",
    new_password: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    disRememberResetApi(data).then((res) => {
      props.history.push("/login");
    });
  };

  const validationSchemaLogin = Yup.object({
    token: Yup.string().required(t("کد را وارد کنید.")),
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
    new_password: Yup.string().required(t("رمز عبور جدید را وارد کنید.")),
  });

  return (
    <>
      <Row className="justify-content-center flex-column mb-5">
        <h6>{t("رمز عبور خود را تنظیم کنید")}</h6>
        <p className="fn12 m-0">{t("کد به ایمیل شما ارسال شد")}</p>
        <p className="fn12">
          {t("لطفا کد را وارد کرده و گذرواژه جدیدی ایجاد کنید")}.
        </p>
      </Row>
      <Row className="justify-content-center flex-column">
        <Formik
          initialValues={initialLoginValues}
          onSubmit={submitLoginForm}
          validationSchema={validationSchemaLogin}
        >
          {(props) => (
            <Form ref={form}>
              <div className="mb-3">
                <div className=" p-1">
                  <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                    {props.values.token && (
                      <p className="fn12 m-0">{t("کد")}</p>
                    )}
                    <input
                      type="number"
                      name="token"
                      placeholder={t("کد")}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      className="w-100 fn12"
                    />
                  </div>
                </div>
                <ErrorMessage name="token">
                  {(errMsg) => (
                    <div className="text-danger fn10 mt-1">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              <div className="mb-3">
                <div className=" p-1">
                  <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                    {props.values.email && (
                      <p className="fn12 m-0">{t("ایمیل")}</p>
                    )}
                    <input
                      type="email"
                      name="email"
                      placeholder={t("ایمیل")}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      className="w-100 fn12"
                    />
                  </div>
                </div>
                <ErrorMessage name="email">
                  {(errMsg) => (
                    <div className="text-danger fn10 mt-1">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              <div className="mb-3">
                <div className=" p-1">
                  <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                    {props.values.new_password && (
                      <p className="fn12 m-0">{t("رمز عبور جدید")}</p>
                    )}
                    <input
                      type="password"
                      name="new_password"
                      placeholder={t("رمز عبور جدید")}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                      className="w-100 fn12"
                    />
                  </div>
                </div>
                <ErrorMessage name="new_password">
                  {(errMsg) => (
                    <div className="text-danger fn10 mt-1">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              <button className="btn btn-primary formBtn mt-4">
                {t("ورود")}
              </button>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
};

const ForgotPasswordSecond = withRouter(ForgotPasswordSecondComp);

export { ForgotPasswordSecond };
